/** Shim for react-horizontal-timeline (expects react-icons@2 path). */
const { FaAngleLeft } = require('react-icons/fa');

module.exports = FaAngleLeft;
